import(/* webpackMode: "eager" */ "/home/metha/İndirilenler/starbucksweb/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/metha/İndirilenler/starbucksweb/src/components/BottomNav.tsx");
;
import(/* webpackMode: "eager" */ "/home/metha/İndirilenler/starbucksweb/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/metha/İndirilenler/starbucksweb/src/components/ui/AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/metha/İndirilenler/starbucksweb/src/components/ui/AppLogo.tsx");
